<template>
  <div class="top-nav">
    <!-- 左侧logo和公司名称 -->
    <div class="left">
      <img src="@/image/logo.png" alt class="logo" />
      <div class="company-name">
        <div class="name-cn">竞拍侠后台管理系统</div>
        <div class="name-en">Store Online Mall VIP System</div>
      </div>
    </div>

    <!-- 右侧功能按钮 -->
    <div class="right">
      <div class="badge" @click="noticeBtn">
        通知
        <el-badge class="mark" :value="0" />
      </div>
      <!-- 用户 -->
      <div class="right_dom1" @click="tuichuBtn">
        <img src="@/image/user.png" alt srcset style="width: 40px; height: 40px" />
        <!-- 身份 -->
        <div>
          {{
          userInfo.role_name
          }}
          {{ userInfo.username ? userInfo.username : "请登录账户" }}
        </div>
        <!-- 切换账户 -->
        <div class="tuichuBtn">
          <el-tooltip class="item" effect="dark" content="切换账号" placement="bottom">
            <img src="@/image/header/icon.png" alt srcset style="width: 15px; height: 15px" />
          </el-tooltip>
        </div>
      </div>
      <!-- 切换全屏 -->
      <img
        class="handleFullScreen"
        @click="handleFullScreen"
        :src="
          !isFullscreen
            ? require('../../image/header/quanping.png')
            : require('../../image/header/quxiaoquanping.png')
        "
        alt
        srcset
        style="width: 40px; height: 40px; display: block"
      />
    </div>
  </div>
</template>

<script>
import { loginOutApi } from "@/services/systemPage/admin_user.js";
import { mapState } from "vuex";
import screenfull from "screenfull";
export default {
  name: "TopNav",
  data() {
    return {
      isFullscreen: false
    };
  },
  computed: {
    ...mapState(["userInfo"])
  },
  mounted() {
    // screenfull在这里有一个on方法，监控事件的触发
    screenfull.on("change", () => {
      this.isFullscreen = screenfull.isFullscreen;
    });
  },
  methods: {
    noticeBtn() {
      this.$message.info("暂无通知");
    },
    /* 退出账户 */
    tuichuBtn() {
      this.$confirm("我们会保留您的账户数据，是否确认退出?", "退出登录", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        loginOutApi().then(resp => {
          if (resp.code == 200) {
            this.$message({
              type: "success",
              message: "已安全退出账户!"
            });
          }
          this.$router.push({ name: "Login" });
        });
      });
    },
    /* 全屏 */
    handleFullScreen() {
      if (!screenfull.enabled) {
        this.$message.info("您的浏览器版本过低，不支持全屏浏览");
        return false;
      }
      screenfull.toggle();
      this.isFullscreen = !this.isFullscreen;
    }
  }
};
</script>

<style scoped lang="less">
.top-nav {
  height: 60px;
  background: #fff;
  line-height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  padding: 0 20px;

  .left {
    display: flex;
    align-items: center;

    .logo {
      width: 40px;
      height: 40px;
      margin-right: 15px;
    }

    .company-name {
      .name-cn {
        font-size: 18px;
        font-weight: 600;
        color: #3d4148;
        line-height: 24px;
      }

      .name-en {
        font-size: 12px;
        color: #909399;
        line-height: 16px;
      }
    }
  }

  .right {
    display: flex;
    align-items: center;
    gap: 20px;

    .badge {
      cursor: pointer;
      &:hover {
        color: rgb(31, 129, 235);
      }
    }

    .right_dom1 {
      display: flex;
      align-items: center;
      gap: 10px;
      cursor: pointer;

      &:hover {
        color: rgb(31, 129, 235);
      }

      .tuichuBtn {
        cursor: pointer;
      }
    }

    .handleFullScreen {
      cursor: pointer;
    }
  }
}
</style>
